import { Refresh } from "@mui/icons-material";
import { Button, Divider, Slider, Switch, Typography, TextField, Alert } from "@mui/material";
import { Box, Container, Stack } from "@mui/system";
import { useCustomTheme } from "../context/Theme/ThemeContext";
import { useState } from "react";
import axios from "axios";
import { useLogin } from "../context/Login/LoginContext";
import api from "../api";
import { hashPassword } from "../util/hash";
import { getBackendUrl } from "../util/envFn";

const Setting = () => {
    const { isLoggedIn } = useLogin();

    return (
        <Stack alignItems="center" overflow="auto" height="100dvh" width="100dvw">
            <Container maxWidth="md">
                <Typography variant="h4" pt={2}>Setting</Typography>
                <Divider sx={{ width: '80%', my: 2 }} />

                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: {
                        xs: '1fr',        // Single column on mobile
                        md: 'repeat(2, 1fr)' // Two equal columns on medium screens and up
                    },
                    gap: 3,
                    width: '80%',
                    minWidth: "300px",
                    pb: 5
                }}>
                    <Box sx={{
                        gridRow: 'span 6',
                        gridColumn: 'span 2',
                        // gridColumn: 'span 1',
                        display: isLoggedIn ? 'block' : 'none'
                    }}>
                        <PasswordSetting />
                    </Box>
                    <Box sx={{
                        gridRow: 'span 10',
                        gridColumn: 'span 2'
                        // gridColumn: 'span 1'
                    }}>
                        <FontSizeSetting />
                    </Box>
                    {/* <TypographySetting />
                <TypographySetting />
                <TypographySetting />
                <TypographySetting />
                <TypographySetting />
                <TypographySetting />
                <TypographySetting />
                <TypographySetting /> */}

                </Box >
            </Container>
        </Stack>
    )
}

const TypographySetting = () => {
    return (
        <Stack direction="row" alignItems="center" gap={2} >
            <Typography variant="h6" sx={{ whiteSpace: 'nowrap' }}>Setting</Typography>
            <Switch />
        </Stack>
    )
}

const FontSizeSetting = () => {
    const { baseFontSize, setBaseFontSize } = useCustomTheme();

    return (
        <Stack pt={2} gap={2} >
            <Stack direction="row" alignItems="center" gap={2}>
                <Typography variant="h6" sx={{ whiteSpace: 'nowrap' }}>Font Size</Typography>
                <Slider
                    value={baseFontSize}
                    onChange={(e, newValue) => setBaseFontSize(newValue as number)}
                    min={0.8}
                    max={1.5}
                    step={0.01}
                />
                <Button variant="outlined" onClick={() => setBaseFontSize(1)}>
                    < Refresh />
                </Button>
            </Stack>
            <Stack p={2} gap={4} bgcolor="background.paper" borderRadius={2} boxShadow={2}>
                <Typography variant="h1">Hello</Typography>
                <Typography variant="h2">Hello</Typography>
                <Typography variant="h3">Hello</Typography>
                <Typography variant="h4">Hello</Typography>
                <Typography variant="h5">Hello</Typography>
                <Typography variant="h6">Hello</Typography>
                <Typography variant="body1">Hello</Typography>
            </Stack>
        </Stack>
    )
}

const PasswordSetting = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        // Reset states
        setError('');
        setSuccess(false);

        // Validation
        if (!currentPassword || !newPassword || !confirmPassword) {
            setError('All fields are required');
            return;
        }

        if (newPassword !== confirmPassword) {
            setError('New passwords do not match');
            return;
        }

        if (newPassword.length < 6) {
            setError('New password must be at least 6 characters long');
            return;
        }

        setLoading(true);
        api.post(getBackendUrl('/update-password'), {
            currentPassword: await hashPassword(currentPassword),
            newPassword: await hashPassword(newPassword)
        }).then((res) => {
            setSuccess(true);
            // Clear form
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        }).catch((err) => {
            setError(err.response?.data?.message || 'Failed to update password');
        }).finally(() => {
            setLoading(false);
        });
    };

    return (
        <Stack pt={2} gap={2}>
            <Typography variant="h5">Update Password</Typography>
            <Box component="form" onSubmit={handleSubmit}>
                <Stack spacing={2} p={2} bgcolor="background.paper" borderRadius={2} boxShadow={2}>
                    {error && <Alert severity="error">{error}</Alert>}
                    {success && <Alert severity="success">Password updated successfully!</Alert>}

                    <TextField
                        label="Current Password"
                        type="password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        fullWidth
                        required
                    />

                    <TextField
                        label="New Password"
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        fullWidth
                        required
                    />

                    <TextField
                        label="Confirm New Password"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        fullWidth
                        required
                        error={newPassword !== confirmPassword && confirmPassword !== ''}
                        helperText={newPassword !== confirmPassword && confirmPassword !== '' ? 'Passwords do not match' : ''}
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        disabled={loading}
                        sx={{ mt: 2 }}
                    >
                        {loading ? 'Updating...' : 'Update Password'}
                    </Button>
                </Stack>
            </Box>
        </Stack>
    );
};

export default Setting; 
